<script lang="ts" setup>
import { clearError } from '#app';
import type { NuxtError } from '#app';
import { Home } from 'lucide-vue-next';

import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { useLocale } from '@sigma/client/i18n/useLocale.js';
import { LandingRoute } from '@sigma/patient-common/routes.js';
import Button from '@sigma/ui/Button.vue';
import ErrorPage from '@sigma/ui/ErrorPage.vue';

import * as l from './error.loc.js';

defineProps({
  error: Object as () => NuxtError,
});

const t = useTranslate();
const locale = useLocale();
</script>

<template>
  <div :class="css.container">
    <ErrorPage :error="error">
      <template #actions>
        <Button
          variant="primary"
          color="black"
          size="xlarge"
          rounded
          :icon="Home"
          :link="LandingRoute({ locale })"
          @click="clearError()"
        >
          {{ t(l.backToHome) }}
        </Button>
      </template>
    </ErrorPage>
  </div>
</template>

<style lang="scss" module="css">
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: $space-xlarge $spacing-24;
}
</style>
